import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

export default function TestimonialCard({ image, quote, name, rating, position,gapOption }) {
  const isImageLeft = position === 'left';

  return (
    <Box
      display="flex"
      flexDirection={isImageLeft ? 'row' : 'row-reverse'}
      alignItems="center"
      justifyContent="space-between"
      sx={{
        maxWidth: 900,
        overflow: 'hidden',
        mb:gapOption?3: 1,
        mt: 4,
      }}
    >
      {/* Image with stars above */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: isImageLeft?'end':'start',
          width: '50%',
          //   pr: isImageLeft ? 2 : 0,
          //   pl: isImageLeft ? 0 : 2,
        }}
      >
        <Box mb={1.3} display="flex" justifyContent="center">
          {[...Array(rating)].map((_, i) => (
            <StarIcon key={i} sx={{ color: '#FFC107', fontSize: 30, mx: 0.2 }} />
          ))}
        </Box>
        <Box
          component="img"
          src={image}
          alt={name}
          sx={{
            width: '100%',
            height: 296,
            objectFit: 'cover',
            borderTopLeftRadius: isImageLeft ? 0 : 12,
            borderBottomLeftRadius: isImageLeft ? 0 : 12,
            borderTopRightRadius: isImageLeft ? 12 : 0,
            borderBottomRightRadius: isImageLeft ? 12 : 0,
          }}
        />
      </Box>

      <Box
        flex={1}
        p={2}
        mt={4}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        ml={isImageLeft?1:3}
        mr={isImageLeft?4:1.5}
        width="50%"
      >
        <Box
          component="img"
          src="/assets/images/Home/mobile/quote.png"
          alt="quote"
          sx={{ width: 39, height: 29, mb: 1 }}
        />
        <Box width="100%">
          <Typography className="merri-weather-text-lighter" sx={{ fontSize: 15, color: '#646D71', mb: 1 }}>
            {quote}
          </Typography>
          <Typography
            className="merri-weather-text-lighter"
            variant="body2"
            sx={{
              background: `linear-gradient(to bottom, #DF4242 0%, #686868 100%)`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontWeight: 600,
            }}
          >
            {name}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

TestimonialCard.propTypes = {
  image: PropTypes.string.isRequired,
  quote: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  rating: PropTypes.number,
  position: PropTypes.oneOf(['left', 'right']),
  gapOption:PropTypes.string,
};
